import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-message-modal',
    templateUrl: './message-modal.component.html',
    styleUrls: ['./message-modal.component.scss'],
    standalone: false
})
export class MessageModalComponent {
  @Input() title: string = 'Success';
  @Input() message: string = '';

  constructor(public readonly activeModal: NgbActiveModal) {}
}
